import { TableContainer } from "@mui/material";
import Paper from "@mui/material/Paper";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { addToUserAPI } from "../../../Store/Action/UserAction";
import Strings from "../../../Config/Strings";
import TopNavBar from "../../../Components/TopNavbar";
import BreadcrumbsComponent from '../../../Components/BreadCrumbs';
import LeftSideNav from '../../../Components/LeftSideNav';
import ManufactureForm from "./Controller/ManufactureForm";
import Fonts from "../../../Config/Fonts";
import Colors from "../../../theme/Colors";

const AddManufactures = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/", text: "Home" },
      { key: "2", href: "/manufacturesList", text: "Manufacturer" },
      { key: "3", href: "/addManufactures", text: "Add Manufacturer" },
    ]);
  }, []);

  const onSubmit = async ({ formData, user_state, user_city, user_role_id }) => {
    const requestData = {};
    formData.forEach((value, key) => {
      requestData[key] = value;
    });
    requestData.user_state = user_state;
    requestData.user_city = user_city;
    requestData.user_role_id = user_role_id
    try {
      await dispatch(
        addToUserAPI(requestData, (isSuccess, response) => {
          if (isSuccess?.status === true) {
            toast.success("User Added Successfully");
            navigate("/userList");
          } else {
            toast.error(response?.error?.message || Strings.somethingWentWrongError);
          }
        })
      );
    } catch (error) {
      console.log("Error dispatching addToUserAPI:", error);
      toast.error("An unexpected error occurred. Please try again.");
    }
  };

  return (
    <div style={mainContainer}>
      <LeftSideNav />

      <div style={leftNavContainer}>
        <div style={topBar}>
          <TopNavBar />

          <div style={pageTitle}>
            <h2>Manufacturer</h2>
          </div>

          <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
        </div>

        <TableContainer component={Paper} style={tableContainer}>
          <h1 style={mainHeadingStyle}>Personal Information</h1>
          <hr />
          <ManufactureForm onSubmit={onSubmit}/>
        </TableContainer>
      </div>

    </div>
  );
};

const mainContainer = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflowX: "hidden",
  overflowY: "hidden",
};

const leftNavContainer = {
  display: "grid",
  gridTemplateRows: "15% 80%",
  backgroundColor: "#F0F5FF",
};

const topBar = {
  backgroundColor: "white",
  height: "7vh",
  width: "100%",
};

const pageTitle = {
  marginLeft: "30px",
  justifyContent: "flex-start",
  display: "flex",
};

const tableContainer = {
  width: "75vw",
  border: "1px solid #ccc",
  borderRadius: "15px",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  marginTop: "40px",
  paddingLeft: "20px",
  paddingRight: "20px",
  marginLeft: "30px",
};

const mainHeadingStyle = {
  fontSize: 16,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans,
  color: Colors.black,
  display: "flex",
  marginTop: "20px",
  marginBottom: "20px",
};

export default AddManufactures;
